export enum UncertainDataEntryReasons { 
  unknown = 0,
  noMedicalInsurance = 1,
}
